<template>
	<div class="d-flex">
		<v-select
			placeholder="Select a campaign"
			class="flex-grow-1"
	        label="title"                                
	        :options="options.campaigns"
	        :reduce="title => title.id"
	        v-model="selected"
		/>
		<span class="btn btn-primary ml-1 text-nowrap" @click="addCampaignStop()">Add to Campaign</span>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		props: ['physician_id'],

		data() {
			return {
				campaigns: null,
				selected: null,
			}
		},

		// mounted() {
		// 	axios.get('/api/campaigns/ids').then(({data}) => {
		// 		this.campaigns = data;
		// 	});
		// },

		methods: {
			addCampaignStop() {
				axios.post(`/api/campaign-visits`, { 
					added_visits: [this.physician_id],
					campaign_id: this.selected,
				}).then(({data}) => {
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 4000,
	                    icon: 'success',
	                    title: 'Campaign visit saved'
	                });

	                this.$emit('campaign_visit_added', data);
	            });									
			},

		},

		computed: mapState(['options'])
	}
</script>